import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[header-bg-color]'
})
export class HeaderBgColorDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer
  ) {
    this.setColor();
  }

  setColor() {
    let background_color = '#4e8ef7';
    if (localStorage.getItem('header_data') && localStorage.getItem('header_data') != '') {
      let header_data = JSON.parse(localStorage.getItem('header_data'));
      if (header_data['background_color']) {
        background_color = header_data['background_color'];
      }
    }
    
    this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', background_color);
  }
}


// WEBPACK FOOTER //
// ./src/directives/header-bg-color/header-bg-color.ts